import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import createStyleSheets from 'utils/createStyleSheets';
import { rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import Transaction from './Transaction';
import { formatDateForItem } from '../utils';
import { isWeb } from '../../../constants';
const InterestActivityItem = ({ item, isFirstInSection, isLastInSection, withWrapper }) => {
    const styles = useStyles(styleSet);
    const borderStyles = useMemo(() => [styles.wrapper, isFirstInSection && styles.firstItem, isLastInSection && styles.lastItem], [styles.wrapper, styles.firstItem, styles.lastItem, isFirstInSection, isLastInSection]);
    return (<View style={withWrapper ? borderStyles : null}>
      <Transaction type={'INTEREST'} status={item.status} title={item.title} amount={item.amount} formattedDate={formatDateForItem(item.timestamp)}/>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    wrapper: {
        marginHorizontal: rem(16),
        backgroundColor: colors.cards.onDark,
        ...(isWeb && { paddingHorizontal: rem(8) }),
    },
    firstItem: {
        borderTopLeftRadius: rem(16),
        borderTopRightRadius: rem(16),
        ...(isWeb && { paddingTop: rem(8) }),
    },
    lastItem: {
        borderBottomLeftRadius: rem(16),
        borderBottomRightRadius: rem(16),
        ...(isWeb && { paddingBottom: rem(8) }),
    },
}));
export default memo(InterestActivityItem);
